export const BOOK_NAMES = {
  // New Testament
  Mt:    { en: 'Matthew',          es: 'Mateo',              zh: '馬太福音',     sc: '马太福音' },
  Mk:    { en: 'Mark',             es: 'Marcos',             zh: '馬可福音',     sc: '马可福音' },
  Lk:    { en: 'Luke',             es: 'Lucas',              zh: '路加福音',     sc: '路加福音' },
  Jn:    { en: 'John',             es: 'Juan',               zh: '約翰福音',     sc: '约翰福音' },
  Acts:  { en: 'Acts',             es: 'Hechos',             zh: '使徒行傳',     sc: '使徒行传' },
  Rm:    { en: 'Romans',           es: 'Romanos',            zh: '羅馬書',       sc: '罗马书' },
  '1Co': { en: '1 Corinthians',    es: '1 Corintios',        zh: '哥林多前書',   sc: '哥林多前书' },
  '2Co': { en: '2 Corinthians',    es: '2 Corintios',        zh: '哥林多後書',   sc: '哥林多后书' },
  Gal:   { en: 'Galatians',        es: 'Gálatas',            zh: '加拉太書',     sc: '加拉太书' },
  Eph:   { en: 'Ephesians',        es: 'Efesios',            zh: '以弗所書',     sc: '以弗所书' },
  Phil:  { en: 'Philippians',      es: 'Filipenses',         zh: '腓立比書',     sc: '腓立比书' },
  Col:   { en: 'Colossians',       es: 'Colosenses',         zh: '歌羅西書',     sc: '歌罗西书' },
  '1Th': { en: '1 Thessalonians',  es: '1 Tesalonicenses',   zh: '帖撒羅尼迦前書', sc: '帖撒罗尼迦前书' },
  '2Th': { en: '2 Thessalonians',  es: '2 Tesalonicenses',   zh: '帖撒羅尼迦後書', sc: '帖撒罗尼迦后书' },
  '1Ti': { en: '1 Timothy',        es: '1 Timoteo',          zh: '提摩太前書',   sc: '提摩太前书' },
  '2Ti': { en: '2 Timothy',        es: '2 Timoteo',          zh: '提摩太後書',   sc: '提摩太后书' },
  Tit:   { en: 'Titus',            es: 'Tito',               zh: '提多書',       sc: '提多书' },
  Phm:   { en: 'Philemon',         es: 'Filemón',            zh: '腓利門書',     sc: '腓利门书' },
  Heb:   { en: 'Hebrews',          es: 'Hebreos',            zh: '希伯來書',     sc: '希伯来书' },
  Jas:   { en: 'James',            es: 'Santiago',           zh: '雅各書',       sc: '雅各书' },
  '1Pe': { en: '1 Peter',          es: '1 Pedro',            zh: '彼得前書',     sc: '彼得前书' },
  '2Pe': { en: '2 Peter',          es: '2 Pedro',            zh: '彼得後書',     sc: '彼得后书' },
  '1Jn': { en: '1 John',           es: '1 Juan',             zh: '約翰一書',     sc: '约翰一书' },
  '2Jn': { en: '2 John',           es: '2 Juan',             zh: '約翰二書',     sc: '约翰二书' },
  '3Jn': { en: '3 John',           es: '3 Juan',             zh: '約翰三書',     sc: '约翰三书' },
  Jude:  { en: 'Jude',             es: 'Judas',              zh: '猶大書',       sc: '犹大书' },
  Rev:   { en: 'Revelation',       es: 'Apocalipsis',        zh: '啟示錄',       sc: '启示录' },
  // Old Testament
  Gen:   { en: 'Genesis',          es: 'Génesis',            zh: '創世記',       sc: '创世记' },
  Exo:   { en: 'Exodus',           es: 'Éxodo',              zh: '出埃及記',     sc: '出埃及记' },
  Lev:   { en: 'Leviticus',        es: 'Levítico',           zh: '利未記',       sc: '利未记' },
  Num:   { en: 'Numbers',          es: 'Números',            zh: '民數記',       sc: '民数记' },
  Deut:  { en: 'Deuteronomy',      es: 'Deuteronomio',       zh: '申命記',       sc: '申命记' },
  Josh:  { en: 'Joshua',           es: 'Josué',              zh: '約書亞記',     sc: '约书亚记' },
  Judg:  { en: 'Judges',           es: 'Jueces',             zh: '士師記',       sc: '士师记' },
  Ruth:  { en: 'Ruth',             es: 'Rut',                zh: '路得記',       sc: '路得记' },
  '1Sam':{ en: '1 Samuel',         es: '1 Samuel',           zh: '撒母耳記上',   sc: '撒母耳记上' },
  '2Sam':{ en: '2 Samuel',         es: '2 Samuel',           zh: '撒母耳記下',   sc: '撒母耳记下' },
  '1Kgs':{ en: '1 Kings',          es: '1 Reyes',            zh: '列王紀上',     sc: '列王纪上' },
  '2Kgs':{ en: '2 Kings',          es: '2 Reyes',            zh: '列王紀下',     sc: '列王纪下' },
  '1Chr':{ en: '1 Chronicles',     es: '1 Crónicas',         zh: '歷代志上',     sc: '历代志上' },
  '2Chr':{ en: '2 Chronicles',     es: '2 Crónicas',         zh: '歷代志下',     sc: '历代志下' },
  Ezra:  { en: 'Ezra',             es: 'Esdras',             zh: '以斯拉記',     sc: '以斯拉记' },
  Neh:   { en: 'Nehemiah',         es: 'Nehemías',           zh: '尼希米記',     sc: '尼希米记' },
  Esth:  { en: 'Esther',           es: 'Ester',              zh: '以斯帖記',     sc: '以斯帖记' },
  Job:   { en: 'Job',              es: 'Job',                zh: '約伯記',       sc: '约伯记' },
  Ps:    { en: 'Psalms',           es: 'Salmos',             zh: '詩篇',         sc: '诗篇' },
  Prov:  { en: 'Proverbs',         es: 'Proverbios',         zh: '箴言',         sc: '箴言' },
  Eccl:  { en: 'Ecclesiastes',     es: 'Eclesiastés',        zh: '傳道書',       sc: '传道书' },
  Song:  { en: 'Song of Songs',    es: 'Cantares',           zh: '雅歌',         sc: '雅歌' },
  Isa:   { en: 'Isaiah',           es: 'Isaías',             zh: '以賽亞書',     sc: '以赛亚书' },
  Jer:   { en: 'Jeremiah',         es: 'Jeremías',           zh: '耶利米書',     sc: '耶利米书' },
  Lam:   { en: 'Lamentations',     es: 'Lamentaciones',      zh: '耶利米哀歌',   sc: '耶利米哀歌' },
  Ezek:  { en: 'Ezekiel',          es: 'Ezequiel',           zh: '以西結書',     sc: '以西结书' },
  Dan:   { en: 'Daniel',           es: 'Daniel',             zh: '但以理書',     sc: '但以理书' },
  Hos:   { en: 'Hosea',            es: 'Oseas',              zh: '何西阿書',     sc: '何西阿书' },
  Joel:  { en: 'Joel',             es: 'Joel',               zh: '約珥書',       sc: '约珥书' },
  Amos:  { en: 'Amos',             es: 'Amós',               zh: '阿摩司書',     sc: '阿摩司书' },
  Obad:  { en: 'Obadiah',          es: 'Abdías',             zh: '俄巴底亞書',   sc: '俄巴底亚书' },
  Jonah: { en: 'Jonah',            es: 'Jonás',              zh: '約拿書',       sc: '约拿书' },
  Mic:   { en: 'Micah',            es: 'Miqueas',            zh: '彌迦書',       sc: '弥迦书' },
  Nah:   { en: 'Nahum',            es: 'Nahúm',              zh: '那鴻書',       sc: '那鸿书' },
  Hab:   { en: 'Habakkuk',         es: 'Habacuc',            zh: '哈巴谷書',     sc: '哈巴谷书' },
  Zeph:  { en: 'Zephaniah',        es: 'Sofonías',           zh: '西番雅書',     sc: '西番雅书' },
  Hag:   { en: 'Haggai',           es: 'Hageo',              zh: '哈該書',       sc: '哈该书' },
  Zech:  { en: 'Zechariah',        es: 'Zacarías',           zh: '撒迦利亞書',   sc: '撒迦利亚书' },
  Mal:   { en: 'Malachi',          es: 'Malaquías',          zh: '瑪拉基書',     sc: '玛拉基书' },
};

export const NT_BOOKS = [
  'Mt','Mk','Lk','Jn','Acts','Rm','1Co','2Co','Gal','Eph','Phil','Col',
  '1Th','2Th','1Ti','2Ti','Tit','Phm','Heb','Jas','1Pe','2Pe','1Jn','2Jn','3Jn','Jude','Rev',
];

export const OT_BOOKS = [
  'Gen','Exo','Lev','Num','Deut','Josh','Judg','Ruth','1Sam','2Sam',
  '1Kgs','2Kgs','1Chr','2Chr','Ezra','Neh','Esth','Job','Ps','Prov',
  'Eccl','Song','Isa','Jer','Lam','Ezek','Dan','Hos','Joel','Amos',
  'Obad','Jonah','Mic','Nah','Hab','Zeph','Hag','Zech','Mal',
];

export const NT_SET = new Set(NT_BOOKS);

// Normalize any book abbreviation (Chinese, Spanish, or variant English) → canonical English key
export const ABBR_TO_ENGLISH = {
  // ── Traditional Chinese (ZH) ──────────────────────────────
  '太': 'Mt', '可': 'Mk', '路': 'Lk', '約': 'Jn', '徒': 'Acts',
  '羅': 'Rm', '林前': '1Co', '林後': '2Co', '加': 'Gal', '弗': 'Eph',
  '腓': 'Phil', '西': 'Col', '帖前': '1Th', '帖後': '2Th',
  '提前': '1Ti', '提後': '2Ti', '多': 'Tit', '門': 'Phm', '來': 'Heb',
  '雅': 'Jas', '彼前': '1Pe', '彼後': '2Pe',
  '約一': '1Jn', '約二': '2Jn', '約三': '3Jn', '猶': 'Jude', '啟': 'Rev',
  '創': 'Gen', '出': 'Exo', '利': 'Lev', '民': 'Num', '申': 'Deut',
  '書': 'Josh', '士': 'Judg', '得': 'Ruth',
  '撒上': '1Sam', '撒下': '2Sam', '王上': '1Kgs', '王下': '2Kgs',
  '代上': '1Chr', '代下': '2Chr',
  '拉': 'Ezra', '尼': 'Neh', '斯': 'Esth', '伯': 'Job',
  '詩': 'Ps', '箴': 'Prov', '傳': 'Eccl', '歌': 'Song',
  '賽': 'Isa', '耶': 'Jer', '哀': 'Lam', '結': 'Ezek', '但': 'Dan',
  '何': 'Hos', '珥': 'Joel', '摩': 'Amos', '俄': 'Obad',
  '拿': 'Jonah', '彌': 'Mic', '鴻': 'Nah', '哈': 'Hab',
  '番': 'Zeph', '該': 'Hag', '亞': 'Zech', '瑪': 'Mal',
  // ── Simplified Chinese (SC) — differences only ────────────
  '约': 'Jn', '罗': 'Rm', '林后': '2Co', '帖后': '2Th',
  '提后': '2Ti', '门': 'Phm', '来': 'Heb', '彼后': '2Pe',
  '约一': '1Jn', '约二': '2Jn', '约三': '3Jn', '犹': 'Jude', '启': 'Rev',
  '创': 'Gen', '书': 'Josh', '诗': 'Ps', '传': 'Eccl',
  '赛': 'Isa', '结': 'Ezek', '弥': 'Mic', '鸿': 'Nah',
  '该': 'Hag', '亚': 'Zech', '玛': 'Mal',
  // ── Spanish (Recovery Version, stripped of trailing dot) ──
  'Ro': 'Rm', 'Rom': 'Rm', 'Hch': 'Acts',
  'Gál': 'Gal', 'Gal': 'Gal', 'Ef': 'Eph', 'Fil': 'Phil',
  'Flm': 'Phm', 'Stg': 'Jas', '1P': '1Pe', '2P': '2Pe', 'Ap': 'Rev',
  'Gén': 'Gen', 'Gn': 'Gen', 'Éx': 'Exo', 'Ex': 'Exo',
  'Nú': 'Num', 'Nm': 'Num', 'Dt': 'Deut',
  'Jos': 'Josh', 'Jue': 'Judg', 'Rut': 'Ruth', 'Rt': 'Ruth',
  '1Re': '1Kgs', '2Re': '2Kgs', '1Cr': '1Chr', '2Cr': '2Chr',
  'Esd': 'Ezra', 'Est': 'Esth',
  'Sal': 'Ps', 'Ecl': 'Eccl', 'Cant': 'Song', 'Cnt': 'Song',
  'Is': 'Isa', 'Ez': 'Ezek',
  'Os': 'Hos', 'Am': 'Amos', 'Abd': 'Obad', 'Jon': 'Jonah',
  'Mi': 'Mic', 'Sof': 'Zeph', 'Zac': 'Zech',
  // ── Actual short abbreviations used in the data ───────────
  // NT
  'Ac': 'Acts', 'Co': 'Col', 'Ep': 'Eph', 'Ga': 'Gal',
  'He': 'Heb', 'Ja': 'Jas', 'Pp': 'Phil', 'Rv': 'Rev', 'Tt': 'Tit',
  '1J': '1Jn', '1P': '1Pe', '2P': '2Pe',
  // OT
  'Dn': 'Dan', 'Dt': 'Deut', 'Ec': 'Eccl', 'Es': 'Esth',
  'Ex': 'Exo', 'Ezk': 'Ezek', 'Ezr': 'Ezra', 'Gn': 'Gen',
  'Hb': 'Hab', 'Hg': 'Hag', 'Ho': 'Hos', 'Is': 'Isa',
  'Ja': 'Jas', 'Jb': 'Job', 'Je': 'Jer', 'Jg': 'Judg',
  'Jl': 'Joel', 'Jnh': 'Jonah', 'Js': 'Josh', 'La': 'Lam',
  'Lv': 'Lev', 'Mi': 'Mic', 'Ml': 'Mal', 'Na': 'Nah',
  'Ne': 'Neh', 'Nm': 'Num', 'Ob': 'Obad', 'Pr': 'Prov',
  'Ru': 'Ruth', 'Zc': 'Zech', 'Zp': 'Zeph', 'Hg': 'Hag',
  '1Ch': '1Chr', '2Ch': '2Chr', '1K': '1Kgs', '2K': '2Kgs',
  '1S': '1Sam', '2S': '2Sam', 'Am': 'Amos',
  // ── English variant spellings ─────────────────────────────
  'Matt': 'Mt', 'Mar': 'Mk', 'Luk': 'Lk', 'Joh': 'Jn',
  'Rom': 'Rm', '1Cor': '1Co', '2Cor': '2Co',
  '1Pet': '1Pe', '2Pet': '2Pe', 'Phlm': 'Phm', 'Psa': 'Ps',
};
